export default __webpack_public_path__ + "static/media/nem-ran.63bedbbc.jpg";